import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b4d716fe&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b4d716fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d716fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d716fe')) {
      api.createRecord('b4d716fe', component.options)
    } else {
      api.reload('b4d716fe', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b4d716fe&scoped=true&", function () {
      api.rerender('b4d716fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6rphBAVPYny/JS/comp/SearchFilterTokens.vue"
export default component.exports